import {
  Tabs as MuiTabs,
  Tab,
  TabProps,
  TabsProps,
  styled,
} from '@mui/material'

const StyledTabs = styled(MuiTabs)<TabsProps>(({ theme }) => ({
  minHeight: 0,
  marginBlockEnd: theme.spacing(3),

  '& .MuiTabs-indicator': {
    backgroundColor: theme.palette.text.primary,
  },
}))

const StyledTab = styled(Tab)<TabProps>(({ theme }) => ({
  ...theme.typography.h3,
  minWidth: 0,
  minHeight: 0,
  paddingInline: 0,
  paddingBlock: '0.25em',
  marginInlineEnd: '1.5em',
  fontWeight: 600,
}))

export { StyledTab, StyledTabs }
